var cov_jd7ki53sy = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Input/styles/index.js",
      hash = "bc45dbc0fe997d804713f3971b627a52c8e6ba3a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Input/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var inputLess = {};
import genaration from '../../utils/classname';
export var inputClass = (cov_jd7ki53sy.s[0]++, genaration(inputLess, 'input'));